
// const usePathFolder = (values) => {
//     return `/${values.map((value, index) => value).join('/')}`;
// };

const usePathFolder = (...values) => {
    return `/${values.join('/')}`;
};

export default usePathFolder;